import { useEffect, useState } from 'react';

import { useDocumentTitle } from 'hooks/document-title';
import AppPage from 'layouts/AppPage/AppPage';
import { Tab } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { OverflowTabs } from 'components/Tabs/Tabs';

import { messagePopUp } from 'api/app-slice';
import { selectCompany } from 'api/company-slice';
import { disable2FA, enable2FA, selectUser, updateUser } from 'api/user-slice';

import { Notifications } from './tabs/Notifications/Notifications';
import { Profile } from './tabs/Profile/Profile';
import { Security } from './tabs/Security/Security';

const Account = () => {
  useDocumentTitle('Your Account | Checkmate');

  const { tab: targetTab } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const company = useSelector(selectCompany);
  const user = useSelector(selectUser);

  const onUserUpdate = data => dispatch(updateUser({ id: user.id, data }));
  const onMessagePopUp = (text, state, hide = true) =>
    dispatch(messagePopUp({ text, state, hide }));
  const onEnable2FA = data => dispatch(enable2FA({ id: user.id, data }));
  const onDisable2FA = () => dispatch(disable2FA(user.id));

  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(targetTab);

  useEffect(() => setTab(targetTab), [targetTab]);

  return (
    <AppPage loading={loading}>
      <AppPage.Header
        title="Your Account"
        subtitle="Below you can view and edit information associated with your account"
      />
      <OverflowTabs
        className="mt-12 mx-12"
        defaultActiveKey="profile"
        onSelect={key => navigate(`/account/${key}`)}
        activeKey={tab}
        mountOnEnter={true}>
        <Tab eventKey="profile" title="Profile">
          <Profile
            user={user}
            company={company}
            updateUser={onUserUpdate}
            setLoading={setLoading}
          />
        </Tab>
        <Tab eventKey="security" title="Security">
          <Security
            user={user}
            company={company}
            setLoading={setLoading}
            messagePopUp={onMessagePopUp}
            onUserUpdate={onUserUpdate}
            onEnable2FA={onEnable2FA}
            onDisable2FA={onDisable2FA}
          />
        </Tab>
        <Tab eventKey="notifications" title="Notifications">
          <Notifications setLoading={setLoading} />
        </Tab>
      </OverflowTabs>
    </AppPage>
  );
};

export default Account;
